import { render, staticRenderFns } from "./userLogin2.vue?vue&type=template&id=4a55b57d&scoped=true&"
import script from "./userLogin2.vue?vue&type=script&lang=js&"
export * from "./userLogin2.vue?vue&type=script&lang=js&"
import style0 from "./userLogin2.vue?vue&type=style&index=0&id=4a55b57d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a55b57d",
  null
  
)

export default component.exports